import Vue from 'vue'
import Utils from '../../core/Utils'
import Specials from '../../core/Specials'

// STATE
const state = {
	board: [],
	config: {
		rows: 4,
		cols: 4,
		value_min: 1,
		value_max: 9,
		life_max: 4,
		cards_in_chain: 4,
		spawn_rates: {
			default: 97,
			special: 3
		},
		levels: {
			2: 100,
			3: 400,
			4: 900,
			5: 1600
		}
	},
	chains: [],
	life: 4,
	score: 0,
	level: 1,
	status: false,
	tuto_step: 1,
	active_card: false
}

// GETTERS
const getters = {
	game: function(state) { return state },
	board: function(state) { return _.sortBy(state.board, 'position') },
	level_max: function(state) { return Object.keys(state.config.levels).length + 1 },
	last_chain: function(state) { return _.last(state.chains) }
}

// ACTIONS
const actions = {


	close_game: function({ commit, state, dispatch }) {
		commit('EDIT_STATE', { status: false });
		commit('SET_BOARD', { board: [] });
	},


	start_game: function({ commit, state, dispatch, rootGetters }) {
		commit('EDIT_STATE', { status: 'playing' });

		setTimeout(function() {
			dispatch('init')
			if (rootGetters.user.first_times.tuto) dispatch('draw_tuto')
			else dispatch('draw')
			sounds.play('draw')
		}, 500)
	},


	init: function({ commit, state }) {
		commit('EDIT_STATE', { life: 4, score: 0, level: 1, chains: [] })

		var board = []
		var total = state.config.rows * state.config.cols

		for (var i = 1; i <= total; i++) {
			board.push({ id: _.uniqueId('slot-'), position: i, card: false })
		}
		commit('SET_BOARD', { board: board });
	},



	draw_tuto: function({ commit, state, dispatch, getters, rootGetters }) {
		if (rootGetters.user.first_times.tuto) {
			var values = [2, 3, 3, 1, 1, 5, 2, 4, 2, 1, 1, 4, 4, 4, 1, 4]
			if (state.tuto_step > 1) values = [4, 5, 3, 4, 3, 5, 2, 's', 2, 1, 4, 1, 5, 3, 5, 4]

			for (var i in getters.board) {
				var slot = getters.board[i];
				if (!slot.card) {
					if (values[i] == 's')
						var card = Utils.generate_card({ type: 'special', slug: 'destruction' })
					else
						var card = Utils.generate_card({ type: 'default', value: values[i] })
					commit('EDIT_SLOT', { slot: slot, card: card })
				}
			}
		} else
			dispatch('draw')
	},


	draw: function({ commit, state, dispatch, getters }) {
		var has_drawed = false;

		for (var i in getters.board) {
			var slot = getters.board[i];
			if (!slot.card) {

				var card = false;
				var type = Utils.get_type_by_rate({ state })
				var value = _.random(state.config.value_min, state.config.value_max - (getters.level_max - state.level));

				if (type == 'default') card = Utils.generate_card({ type: 'default', value: value })
				else card = Utils.generate_card({ type: type })

				// if (!has_drawed) card = Utils.generate_card({ type: 'special' })

				commit('EDIT_SLOT', {
					slot: slot,
					card: card
				})
				has_drawed = true
			}
		}
		if (has_drawed) {
			setTimeout(function() {
				dispatch('check_chains')
			}, 250);
		}
	},


	play_card: function({ commit, state, getters, dispatch }, data) {
		if (data.slot.card) {
			
			if (data.slot.card.type == 'default') {
				dispatch('increment_card', { card: data.slot.card })
			}

			else if (data.slot.card.type == 'special') {
				
				sounds.play('special')
				Specials.play(data.slot, { commit, state, getters, dispatch })
				commit('EDIT_SLOT', { slot: data.slot, card: false })
				
				setTimeout(function() {
					// commit('EDIT_STATE', { life: state.life - 1 })
					if (state.status == 'playing') {
						dispatch('draw')
					}
				}, 250);

			}
		}
	},


	increment_card: function({ commit, state, getters, dispatch }, data) {
		if (data.card.value < state.config.value_max) {
			sounds.play('tap')
			commit('EDIT_STATE', { life: state.life - 1 })
			commit('EDIT_CARD', { card: data.card, value: data.card.value + 1 })
			
			Vue.nextTick(function() {
				dispatch('check_chains')
			})
			
		}
	},


	check_chains: function({ commit, state, dispatch, getters, rootGetters }) {
		var chains = Utils.find_chains({ board: getters.board, config: state.config });
		if (chains.length) {
			for (var i in chains) {
				var value = _.sumBy(chains[i], function(slot) { return slot.card.value })

				// if (value > state.stats.best_value_chain) dispatch('add_stat', { stat: 'best_value_chain', value: value })

				dispatch('add_score', { score: value })

				dispatch('delete_chain', { chain: chains[i] })
				sounds.play('chain')
			}
			commit('EDIT_STATE', { life: state.config.life_max })
			setTimeout(function() {
				if (rootGetters.user.first_times.tuto) dispatch('draw_tuto')
				else dispatch('draw')
			}, 350);
		} else
			dispatch('check_lose')
	},


	delete_chain: function({ commit, state, getters, dispatch }, data) {
		// dispatch('add_chain', { chain: { nb: data.chain.length, value: data.chain[0].card.value } })
		dispatch('add_chain', { chain: data.chain })

		for (var i in data.chain) {
			commit('EDIT_SLOT', { slot: data.chain[i], card: false })
		}
	},


	add_chain: function({ commit, state, getters, dispatch }, data) {
		commit('ADD_CHAIN', { chain: _.cloneDeep(data.chain) })
	},



	check_lose: function({ commit, state, getters, dispatch, rootGetters }, data) {
		if (state.life <= 0) {
			commit('SET_BOARD', { board: [] });
			if (rootGetters.user.best_score < state.score) commit('EDIT_USER', { best_score: state.score });
			dispatch('save_data')
			setTimeout(function() {
				commit('EDIT_STATE', { status: 'lose' });
			}, 1250)
		}
	},


	add_score: function({ commit, state, getters }, data) {
		if (data.score) {
			var new_score = state.score + data.score
			commit('EDIT_STATE', { score: new_score })

			for (var i = 1; i < getters.level_max; i++) {
				if (state.level == i && new_score >= state.config.levels[i+1]) {
					commit('EDIT_STATE', { level: i+1 })
					break
				}
			}
		}
	},


	shuffle: function({ commit, getters, state }) {
		var slots = _.shuffle(getters.board);
		for (var i in slots) {
			commit('EDIT_SLOT', { slot: slots[i], position: parseInt(i) + 1 })
		}
	},


	next_tuto: function({ commit, state, dispatch }, data) {
		if (state.tuto_step) {
			var t = state.tuto_step + 1;
			if (t == 12) {
				t = false;
				commit('EDIT_FIRST_TIMES', { tuto: false });
				dispatch('save_data')
			}
			commit('SET_TUTO', { tuto_step: t });
		}
	}

}

// MUTATIONS
const mutations = {
	EDIT_STATE: function(state, data) {
		for (var i in data) {
			Vue.set(state, i, data[i]);
		}
	},
	EDIT_CONFIG: function(state, data) {
		for (var i in data) {
			Vue.set(state.config, i, data[i]);
		}
	},
	SET_BOARD: function(state, data) {
		Vue.set(state, 'board', data.board);
	},
	ADD_CHAIN: function(state, data) {
		state.chains.push(data.chain)
	},
	EDIT_SLOT: function(state, data) {
		for (var i in data) {
			if (i != 'slot') {
				Vue.set(data.slot, i, data[i]);
			}
		}
	},
	EDIT_CARD: function(state, data) {
		for (var i in data) {
			if (i != 'card') {
				Vue.set(data.card, i, data[i]);
			}
		}
	},
	SET_TUTO: function(state, data) {
		state.tuto_step = data.tuto_step;
	},
	SET_ACTIVE_CARD: function(state, data) {
		state.active_card = data.card;
	}
}

export default { state, getters, actions, mutations }


// WEBPACK FOOTER //
// ./src/store/modules/game.js